module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAnFBMVEUAAAAAaz/80RYAAAD///8Daj/acyWsHyesICzbh44EaT8FbD6SNDWgIy+7LkC/JUKfIiiXMjUGbD7ynRykIjDcFyuPSWF6RW3fFyyhIzHymh2CDBuyJDDbGCelQokoUkfXGy/1vMOgIirZGS22MjwjXzrJHS+kIir0ucAGbUKWMjOeJDC/LCOcPiWbIiuZMTPWcCWvHyyxHjDbg4tbCz6cAAAAAXRSTlMAQObYZgAAAFBJREFUeAFjIAgYgRBEAem/IMZ/JuwqWBhB4DtIBViAixEC3gMFWEACHIxQgCrw5z9IN1iADSzAzvgSLPAXruXXX7gtnGpA/nWILZgOoxwAAMvVEjNCGQNIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/DM.png
// module id = 1125
// module chunks = 0